import React from 'react';
import { cn } from '@ui/lib/utils';

interface CustomListProps<T> {
  items: T[];
  withItemTemplate: (item: T, index: number, position: number) => React.ReactNode;
  className?: string;
  emptyMessage?: string;
}

export function CustomList<T>({
  items,
  withItemTemplate,
  className,
  emptyMessage = 'No items',
}: CustomListProps<T>) {
  if (!items || items.length === 0) {
    return (
      <div className={cn('text-center py-8 text-gray-500', className)}>
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className={cn('space-y-2', className)}>
      {items.map((item, index) => (
        <div key={index}>
          {withItemTemplate(item, index, index)}
        </div>
      ))}
    </div>
  );
}
